import { APP_INITIALIZER, ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { MessageService } from 'primeng/api';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { mfaInterceptor } from './core/interceptors/mfa.interceptor';
import { AuthService } from './core/services/auth.service';
import { AttributionService } from './core/services/attribution.service';
import { AppInsightsErrorHandler } from './core/services/app-insights-error-handler';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor, mfaInterceptor])),
    MessageService,
    // Routes Angular-zone errors to Application Insights (no-op until the SDK is
    // initialised behind Analytics consent).
    { provide: ErrorHandler, useClass: AppInsightsErrorHandler },
    // Read the first-touch ad params off the entry URL before anything can
    // navigate away and drop the query string. Synchronous, and a no-op once
    // something is already stored. See AttributionService.
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [AttributionService],
      useFactory: (attribution: AttributionService) => () => attribution.capture()
    },
    // Cold-start: in web cookie-auth mode, mint an in-memory access token from
    // the httpOnly refresh cookie before the first route guard runs. No-op in
    // legacy/native mode (resolves immediately). See AuthService.bootstrapSession.
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [AuthService],
      useFactory: (auth: AuthService) => () => auth.bootstrapSession()
    }
  ]
};
